import { useMediaQuery } from './useMediaQuery';

const getQuery = (breakPointNumber: number, isMaxWidth: boolean): string =>
  isMaxWidth
    ? `(max-width: ${breakPointNumber - 1}px)`
    : `(min-width: ${breakPointNumber}px)`;

export default function useBreakpointNumber(
  breakPointNumber?: number,
  isMaxWidth = false
): boolean {
  return useMediaQuery(getQuery(breakPointNumber ?? 600, isMaxWidth));
}
